<template>
  <div>
    <template v-if="additional">
      <template
        v-for="photo in photos"
      >
        <v-text-field
          :key="photo.id + '_desc'"
          v-model="photo.description"
          box
          flat
          label="写真名"
          @blur="() => updateDescription(photo)"
        />
        <cp-photo
          :key="photo.id"
          :ref="'additional_' + photo.id"
          :photo="photo"
          :name="'additional_' + photo.id"
          :description="photo.description"
          :confidential="photo.confidential"
          removable
          @upload-error="onError"
          @remove="() => onRemovePhoto(photo)"
          @open-photo-selection="openPhotoSelection"
        />
        <v-divider
          :key="photo.id + '_divider'"
          class="my-4"
        />
      </template>

      <v-btn
        v-if="!formAddPhoto"
        color="primary"
        name="add_photo_btn"
        large
        class="ma-0 px-3"
        @click="formAddPhoto = true"
      >追加</v-btn>
      <template v-else>
        <v-text-field
          key="add_photo_desc"
          v-model="addPhotoDescription"
          name="add_photo_desc"
          box
          flat
          label="写真名"
          @blur="onDescChange"
        />
        <cp-photo
          key="add_photo"
          ref="additional"
          :error="addPhotoError"
          :description="addPhotoDescription"
          name="additional"
          @upload-error="onError"
          @finished="onPhotoFinish"
          @open-photo-selection="openPhotoSelection"
        />
      </template>
    </template>
    <v-form
      v-else
      :ref="refName"
    >
      <cp-photo
        v-for="photo in photosList"
        :ref="photo.name"
        :key="photo.name"
        :photo="getPhoto(photo.name)"
        :name="photo.name"
        :label="photo.label"
        :description="photo.description"
        :confidential="photo.confidential"
        :caption="photo.caption"
        :preview="photo.preview"
        :required="photo.required"
        :data-label-scroll="photo.name"
        @upload-error="onError"
        @open-photo-selection="openPhotoSelection"
      />
    </v-form>
  </div>
</template>

<script>
import Vue from 'vue';
import { GET_PHOTOS, DELETE_PHOTO, UPDATE_CAR_PHOTO } from '../../queries';

function requirePreviews(photos) {
  photos.forEach((photo) => {
    import(`../../assets/photos/PHOTO_${photo.name.toUpperCase()}.jpg`).then(
      (src) => {
        if (src) {
          Vue.set(photo, 'preview', src);
        }
      },
    );
  });
  return photos;
}

export default {
  props: {
    photos: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    additional: {
      type: Boolean,
      default: false,
    },
    tab: {
      type: String,
      default: 'photos',
    },
  },
  data() {
    return {
      photosList: this.items,
      setPhotosRequest: null,
      formAddPhoto: false,
      addPhotoDescription: '',
      addPhotoError: '',
    };
  },
  computed: {
    type() {
      return this.additional ? 'additional_photos' : 'photo_container';
    },
    refName() {
      return `photos-${this.tab}`;
    },
    appointment() {
      return this.$store.state.appointment;
    },
    carId() {
      return this.$store.state.carId;
    },
    showPhotoSelectionDialog() {
      return this.$store.state.showPhotoSelectionDialog;
    },
  },
  mounted() {
    requirePreviews(this.photosList);
  },
  methods: {
    onError({ status }) {
      this.$store.commit('setError', status);
    },
    onDescChange() {
      if (this.addPhotoDescription) {
        this.addPhotoError = '写真を追加してください。';
      }
    },
    onRemovePhoto({ id }) {
      this.$apollo.mutate({
        mutation: DELETE_PHOTO,
        variables: { id },
        refetchQueries: [{
          query: GET_PHOTOS,
          variables: { id: parseInt(this.$route.params.id, 10) },
        }],
      });
    },
    updateDescription({ id, description }) {
      this.$apollo.mutate({
        mutation: UPDATE_CAR_PHOTO,
        variables: { id, value: description, field: 'description' },
        refetchQueries: [{
          query: GET_PHOTOS,
          variables: { id: parseInt(this.$route.params.id, 10) },
        }],
      });
    },
    getPhoto(type) {
      return this.photos.find(p => p.type === `PHOTO_${type.toUpperCase()}`);
    },
    onPhotoFinish() {
      this.addPhotoDescription = '';
      this.formAddPhoto = false;
    },
    openPhotoSelection(photo) {
      this.$emit('update-active', { photo, ref: this.$refs[photo.name] });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fields/PhotoGroup.vue